import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transport-manager-account',
  templateUrl: './transport-manager-account.component.html',
  styleUrls: ['./transport-manager-account.component.css']
})
export class TransportManagerAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
 
}
